<template>
    <div class="property-list" :class="!showComponents ? 'property-list-opacity' : ''" v-if="currentComponent">
        <h3>{{ $t('contrato_rastreabilidade.messages.farm_list.title') }}</h3>
        <el-card>
            <component
                v-model="form.properties"
                :is="currentComponent"
                ref="FarmListComponent"
                :selected.sync="selectedFarms"
            />
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'PropertyList',
    props: {
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-contract/views/components/farm-list/py.vue'
                    )
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        currentComponent() {
            this.$emit('input', {});
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        selectedFarms: {
            get() {
                return this.selected;
            },
            set(value) {
                this.$emit('update:selected', value);
            }
        },
        showComponents() {
            return this.form.properties.length > 0;
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}
.property-list-opacity {
    opacity: 0.5;
}
</style>
